import styled from 'styled-components';
import { Row } from 'common/components';

const SectionRow = styled(Row)`
  width: 100%;
  justify-content: space-between;
`;

export default SectionRow;
